import { render } from "./VoilesVoiliersLogo.vue?vue&type=template&id=375d36fd"
import script from "./VoilesVoiliersLogo.vue?vue&type=script&lang=js"
export * from "./VoilesVoiliersLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__